export default __webpack_public_path__ + "static/media/filter.f57a0007.svg";